
export const chinese1 = [5, 9/8, 81/64, 3/2, 27/16, 2/1];
// Al-Farabi 25-tone/10-Fret Oud
export const AL_FARABI_25_TONE_10_FRET_OUD_1_1 =
    ["1","256/243","32/27","4/3","3/2","128/81","16/9","2/1"];
    
    
export const AL_FARABI_25_TONE_10_FRET_OUD_3_2 = [
    "1","9/8","32/27","4/3","3/2","128/81","16/9","2/1"];

export const AL_FARABI_25_TONE_10_FRET_OUD_PERSIAN_CHARAGAH = [
    "1","162/149","81/64","4/3","3/2","18/11","4096/2187","2/1"
];
